/* eslint-disable max-len */
import { SvgProps } from './types'

export const PeopleGraphIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M24.0727 20.3137L33.612 10.7007L35.7913 14.0599L38 3.50293L27.443 5.71168L30.7543 7.85405L21.1744 17.504L14.869 11.1985L2 24.0712L4.85035 26.9252"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0889 19.687L14.8692 16.9067L17.3139 19.3515"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.7861 28.2678C28.0664 28.2014 28.354 28.1646 28.6564 28.1646H33.6933C35.7251 28.1646 37.3881 29.8276 37.3881 31.8593V38.1094"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.0059 33.7361V38.1536"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.2867 26.5419C33.7531 25.9261 34.4427 24.2381 33.8269 22.7717C33.211 21.3052 31.523 20.6157 30.0566 21.2315C28.5902 21.8473 27.9006 23.5353 28.5164 25.0018C29.1323 26.4682 30.8203 27.1578 32.2867 26.5419Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.61621 38.1056V31.8629C2.61621 29.8274 4.27922 28.1644 6.31098 28.1644H11.348C11.6024 28.1644 11.8494 28.1902 12.0891 28.2382"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.02441 33.736V38.1535"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6306 24.5424C11.993 22.9937 11.0313 21.4445 9.48261 21.0821C7.93395 20.7197 6.38474 21.6814 6.02236 23.2301C5.65998 24.7787 6.62165 26.3279 8.17032 26.6903C9.71898 27.0527 11.2682 26.091 11.6306 24.5424Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5684 38.1537V32.995C12.5684 30.565 14.5559 28.5739 16.9895 28.5739H23.0147C25.4447 28.5739 27.4359 30.5614 27.4359 32.995V38.1537"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4521 35.2407V38.1538"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5859 35.2407V38.1538"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1201 26.1675C23.6191 24.9967 23.8853 22.8324 22.7145 21.3333C21.5437 19.8342 19.3794 19.5681 17.8803 20.7389C16.3812 21.9097 16.1151 24.074 17.2859 25.5731C18.4567 27.0721 20.621 27.3383 22.1201 26.1675Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
